export const TrialOrderPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'sales.trialOrder.list-view',
    UPDATE: 'sales.trialOrder.list-update',
    DELETE: 'sales.trialOrder.list-delete',
  },
});
